<div class="tags-container">
  <app-header-actions [headerTitle]="'TAGS.TITLE'" [headerIcon]="faTag" [config]="headerConfig"
    [count]="filteredtags.length + ' ' + ('TAGS.TITLE' | translate)" [showCount]="true" (addClick)="openCreateModal()"
    (backClick)="goBack()" (filtersChanged)="onHeaderSearch($event)">
  </app-header-actions>

  <div class="content-area">
    <app-item-list [items]="itemsForList" [loading]="loading" [config]="listConfig"
      [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)">
    </app-item-list>
  </div>
</div>

@if (showCreateModal || showEditModal) {
<div class="modal-overlay" (click)="closeModals()">
  <div class="modal-content" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>
        <fa-icon [icon]="faTag"></fa-icon>
        <span>{{ showCreateModal ? ('TAGS.CREATE.TITLE' | translate) : ('TAGS.EDIT.TITLE' | translate) }}</span>
      </h3>
      <button class="close-btn" (click)="closeModals()">
        <fa-icon [icon]="faTimes"></fa-icon>
      </button>
    </div>
    <div class="modal-body">
      <form (ngSubmit)="showCreateModal ? createtag() : updatetag()">
        <div class="form-group">
          <label>
            <fa-icon [icon]="faTag"></fa-icon>
            {{ 'TAGS.FORM.NAME' | translate }}
          </label>
          <input type="text" [(ngModel)]="tagForm.name" name="name"
            [placeholder]="'TAGS.FORM.NAME.PLACEHOLDER' | translate" (input)="onNameChange()" [class.error]="nameError"
            required maxlength="50">
          @if (nameError) {
          <div class="error-message">
            <fa-icon [icon]="faExclamationTriangle"></fa-icon>
            <span>{{ nameError }}</span>
          </div>
          }
        </div>
        <div class="form-group">
          <label>
            <fa-icon [icon]="faInfoCircle"></fa-icon>
            {{ 'TAGS.FORM.DESCRIPTION' | translate }}
          </label>
          <textarea [(ngModel)]="tagForm.description" name="description"
            [placeholder]="'TAGS.FORM.DESCRIPTION.PLACEHOLDER' | translate" rows="3" maxlength="255"></textarea>
        </div>
        <div class="form-group">
          <label>
            <fa-icon [icon]="faPaintBrush"></fa-icon>
            {{ 'TAGS.FORM.COLOR' | translate }}
          </label>
          <div class="color-preview">
            <div class="preview-tag" [style.background-color]="tagForm.bg_color" [style.color]="tagForm.text_color">
              <fa-icon [icon]="faTag"></fa-icon>
              <span>{{ tagForm.name || ('TAGS.FORM.PREVIEW' | translate) }}</span>
            </div>
          </div>
          <div class="color-palette">
            @for (color of predefinedColors; track color) {
            <div class="color-item" [style.background-color]="color.bg_color"
              [title]="color.name + ' - ' + color.bg_color" [class.selected]="tagForm.bg_color === color.bg_color"
              (click)="selectColor(color)"></div>
            }
          </div>
        </div>
        <div class="form-actions">
          <app-button [text]="'BUTTON.CANCEL' | translate" variant="secondary" (clicked)="closeModals()">
          </app-button>
          <app-button
            [text]="isSubmitting ? ('TAGS.SAVING' | translate) : (showCreateModal ? ('BUTTON.CREATE' | translate) : ('BUTTON.SAVE' | translate))"
            variant="primary" [icon]="faCheck" [loading]="isSubmitting"
            [disabled]="!!(isSubmitting || nameError || !tagForm.name.trim())"
            (clicked)="showCreateModal ? createtag() : updatetag()">
          </app-button>
        </div>
      </form>
    </div>
  </div>
</div>
}

@if (showDeleteModal) {
<app-modal-delete-confirm [show]="showDeleteModal" [configKey]="selectedtag?.name || ''" [configType]="'tag'"
  (close)="closeModals()" (confirm)="deletetag()">
</app-modal-delete-confirm>
}